"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ERROR_MESSAGE = void 0;
var _react = require("react");
const ERROR_MESSAGE = exports.ERROR_MESSAGE = 'You must provide either a label, i18nItemLabel, or aria-labelledby prop.';
function useLabelValidation(label, i18nItemLabel) {
  let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  (0, _react.useEffect)(() => {
    if (!label && !i18nItemLabel && !props['aria-labelledby']) {
      throw new Error(ERROR_MESSAGE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
var _default = exports.default = useLabelValidation;